export default "__VITE_ASSET__CLh5$jrc__"